import DatatablesController from '../../../datatables_controller';

export default class extends DatatablesController {
  datatableColumns(){
    return [
      {
        field: 'index',
        title: 'No',
        sortable: false,
        width: 25,
        type: 'number',
        selector: false,
        textAlign: 'center',
        template: function(data) {
          return `
            <span class="font-weight-bolder">${data.index}</span>
          `;
        }
      },
      {
        field: 'name',
        title: 'User',
        sortable: false,
        textAlign: 'left',
        width: 200,
        template: function(data) {
          var html_output = `
            <div class="d-flex align-items-center">
              <div class="symbol symbol-40 symbol-sm flex-shrink-0">
                <img class="" src="${data.user_avatar_url}" alt="photo">
              </div>
              <div class="ml-4">
                <div class="text-dark-75 font-weight-bolder font-size-lg mb-0">${data.name}</div>
                <a href="#" class="text-muted font-weight-bold text-hover-primary">${data.company_name}</a>
              </div>
            </div>
          `;
  
          return html_output;
        }
      },
      {
        field: 'email',
        title: 'Email',
        sortable: false,
        width: 200,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.email}</span>`;
        }
      },
      {
        field: 'total_video',
        title: 'Jumlah Video Materi Ditonton',
        sortable: false,
        textAlign: 'center',
        template: function(data) {
          return `<span class="font-weight-bolder">${data.total_video}</span>`;
        }
      },
      {
        field: 'total_finished_video',
        title: 'Jumlah Video Materi Selesai',
        textAlign: 'center',
        template: function(data) {
          return `<span class="font-weight-bolder">${data.total_finished_video}</span>`;
        }
      },
      {
        field: 'class_attendants',
        title: 'Jumlah Kelas Wajib dihadiri',
        textAlign: 'center',
        template: function(data) {
          return `<span class="font-weight-bolder">${data.class_attendants}</span>`;
        }
      },
      {
        field: 'finished_exams',
        title: 'Ujian Diselesaikan',
        textAlign: 'center',
        template: function(data) {
          return `<span class="font-weight-bolder">${data.finished_exams}</span>`;
        }
      },
      {
        field: 'finished_certificate',
        title: 'Sertifikat Selesai / Didownload',
        textAlign: 'center',
        template: function(data) {
          return `<span class="font-weight-bolder">${data.finished_certificate}</span>`;
        }
      },
      {
        field: 'total_duration_video',
        title: 'Total Durasi Belajar',
        textAlign: 'center',
        template: function(data) {
          return `<span class="font-weight-bolder">${data.total_duration_video}</span>`;
        }
      },
      {
        field: 'completion_rate',
        title: 'Completion Rate',
        textAlign: 'center',
        template: function(data) {
          return `<span class="font-weight-bolder">${data.completion_rate}</span>`;
        }
      },
      {
        field: 'actions',
        title: 'Actions',
        sortable: false,
        width: 280,
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `
            <a class="btn btn-sm btn-primary mr-4" href="${data.show_action}" title="Download">
              <i class="fa fa-eye mr-1"></i>
              Lihat Detail
            </a>
            
            <a class="btn btn-sm btn-success mr-4" href="https://wa.me/${data.formatted_phone}" target="_blank" title="Followup WA">
              <i class="fab fa-whatsapp mr-1"></i>
              Chat WA
            </a>
          `;
        },
      }
      
    ]
  }
}

